var ConfigurationSummaryModel = function(pageModelHndl) {
    var that = this;
    that.AddOfferModal = ko.observable(null);
    that.IsOrderCreationProgressLoading = ko.observable(false);
    that.isLoading = ko.observable(false);
    that.isDependencyLoading = ko.computed(function() {
        return pageModelHndl.pOrderOptionsModelV2.IsLoading()
            || pageModelHndl.pOrderOptionsModelV2.IsDependencyLoading();
    }, this, { pure: true });

    that.articleReference = ko.observable("");
    that.amount = ko.observable(0);
    that.selectedOrderOptions = ko.observableArray([]);
    that.selectedDeliveryCountryId = ko.observable(2);
    that.itemCount = ko.observable(1);
    that.offerModel = new OfferModelV2();
    that.selectedAdditionalWorkIds = ko.observableArray([]);

    that.load = function (articleReference, amount, selectedOrderOptions, selectedDeliveryCountryId, selectedAdditionalWorkIds) {
        that.articleReference(articleReference);
        that.amount(amount);
        that.selectedOrderOptions(selectedOrderOptions);
        that.selectedDeliveryCountryId(selectedDeliveryCountryId);
        that.selectedAdditionalWorkIds(selectedAdditionalWorkIds);
        that.isLoading(true);
        var $summaryEl = $("#productConfigurationSummaryV2");
        $summaryEl.find(".SummaryTable").load($summaryEl.data("url"),
            {
                articleReference: articleReference,
                amount: amount,
                selectedOrderOptions: selectedOrderOptions,
                countryId: selectedDeliveryCountryId,
                itemCount: 1,
                isCatalogueProduct: pageModelHndl.IsCatalogueProduct(),
                selectedAdditionalWorkIds: selectedAdditionalWorkIds
            },
            function () {
                that.isLoading(false);
                that.AdjustProductConfigMode();
            });

        var $spQueryEl = $("#SpQueriesDiv");
        $spQueryEl.find(".SpQueriesArea").load($spQueryEl.data("url"),
        {
            articleReference: articleReference,
                amount: amount,
                selectedOrderOptions: selectedOrderOptions,
                selectedAdditionalWorkIds: selectedAdditionalWorkIds,
                countryId: selectedDeliveryCountryId,
                itemCount: 1
        });
        var $priceCalculationDetailsEl = $("#PriceCalculationDetailsDiv");
        $priceCalculationDetailsEl.find(".PriceCalculationDetailsArea").load($priceCalculationDetailsEl.data("url"),
            {
                articleReference: articleReference,
                amount: amount,
                selectedOrderOptions: selectedOrderOptions,
                selectedAdditionalWorkIds: selectedAdditionalWorkIds,
                countryId: selectedDeliveryCountryId,
                itemCount: 1
            });
    };

    that.addItem = function () {
        pageModelHndl.IsOrderCreationProgressLoading(true);
        var addItemUrl = $("#addToShoppingCartV2").data("url");
        var shoppingCartUrl = $("#shoppingCartV2Index").data("url");
        var data = JSON.stringify({
            articleReference: that.articleReference(),
            amount: that.amount(),
            selectedOrderOptions: that.selectedOrderOptions(),
            countryId: that.selectedDeliveryCountryId(),
            itemCount: that.itemCount(),
            isCatalogueProduct: pageModelHndl.IsCatalogueProduct(),
            selectedAdditionalWorkIds: that.selectedAdditionalWorkIds()
        });

        $.ajax({
            url: addItemUrl,
            type: "POST",
            data: data,
            dataType: "json",
            contentType: "application/json; charset=utf-8",
        }).done(function (data) {
            if (data.Success) {
                window.location.href = shoppingCartUrl;
            } else {
                if (data.ErrorMessage) {
                    alerts.error(data.ErrorMessage);
                }
                else {
                    alerts.error();
                }
                
            }
        }).fail(function() {
            alerts.error();
        }).always(function() {
            fireDataLayerEventAddItem();
            pageModelHndl.IsOrderCreationProgressLoading(false);
        });
    };

    function fireDataLayerEventAddItem() {
        window.dataLayer =
            window.dataLayer || [];
        window.dataLayer.push({
            'event': 'click_add_to_cart',
        });
    }

    that.updateItem = function (model, event) {
        pageModelHndl.IsOrderCreationProgressLoading(true);
        var updateUrl = $(event.currentTarget).data("update-url");
        var shoppingCartUrl = $("#shoppingCartV2Index").data("url");
        var data = JSON.stringify({
            positionNumber: pageModelHndl.EditData().PositionNumber,
            articleReference: that.articleReference(),
            amount: that.amount(),
            selectedOrderOptions: that.selectedOrderOptions(),
            countryId: that.selectedDeliveryCountryId(),
            itemCount: that.itemCount(),
            isCatalogueProduct: pageModelHndl.IsCatalogueProduct(),
            selectedAdditionalWorkIds: that.selectedAdditionalWorkIds()
        });

        $.ajax({
            url: updateUrl,
            type: "POST",
            data: data,
            dataType: "json",
            contentType: "application/json; charset=utf-8"
        }).done(function(data) {
            if (data.Success) {
                window.location.href = shoppingCartUrl;
            } else {
                alerts.error();
            }
        }).fail(function() {
            alerts.error();
        }).always(function() {
            pageModelHndl.IsOrderCreationProgressLoading(false);
        });
    };

    that.openOfferWindow = function()  {
        var window = $("#OfferAddedWindow");
        if (!window.data("kendoWindow")) {
            window.kendoWindow({
                width: "600px",
                title: YourOfferHasBeenCreated,
                open: function() {
                    maximizeKendoWindowOnMobile(this);
                }
            });
        }
        window.data("kendoWindow").open();
        window.data("kendoWindow").center();
    };
    
    that.openOfferWindowBs4 = function()  {
        var modal = that.AddOfferModal();
        if(modal === null) {
            var selector = "#OfferAddedWindow";
            var $dialog = $(selector);
            var Modal = shop.ts.modal.GetModal();
            modal = new Modal(selector, {
                width: "870px",
                title: $dialog.data('title')
            });
            that.AddOfferModal(modal);
        }
        modal.open();
    };

    that.saveForLater = function() {
        that.openOfferWindow();

        that.offerModel.Working(true);
        that.offerModel.Clear();        

        var postData = JSON.stringify({
            articleReference: that.articleReference(),
            amount: that.amount(),
            selectedOrderOptions: that.selectedOrderOptions(),
            countryId: that.selectedDeliveryCountryId(),
            selectedAdditionalWorkIds: that.selectedAdditionalWorkIds()
        });

        $.ajax({
            url: ajaxUrls.offer.AddOffer,
            type: "POST",
            data: postData,
            dataType: "json",
            contentType: "application/json; charset=utf-8"
        }).fail(function() {
            alerts.error();
        }).done(function(data) {
            if (!data.Success) {
                alerts.error();
                return;
            }
            that.offerModel.UpdateData(that.articleReference(),
                that.amount(),
                that.selectedOrderOptions(),
                that.selectedAdditionalWorkIds(),
                that.selectedDeliveryCountryId(),
                data.OfferGrossPrice);
            that.offerModel.OfferId = data.OfferId;
            that.offerModel.UserHasMailHead(data.UserHasMailHead);
            that.offerModel.AddOffer(parseInt(that.amount()), data.OfferGrossPrice);
            $("#OfferIdHidden").attr('value', data.OfferId);
            that.offerModel.Working(false);
        });
    };

    that.saveForLaterBs4 = function() {
        that.openOfferWindowBs4();

        that.offerModel.Working(true);
        that.offerModel.Clear();

        var postData = JSON.stringify({
            articleReference: that.articleReference(),
            amount: that.amount(),
            selectedOrderOptions: that.selectedOrderOptions(),
            countryId: that.selectedDeliveryCountryId(),
            selectedAdditionalWorkIds: that.selectedAdditionalWorkIds(),
            isCatalogueProduct: pageModelHndl.IsCatalogueProduct()
        });

        $.ajax({
            url: ajaxUrls.offer.AddOffer,
            type: "POST",
            data: postData,
            dataType: "json",
            contentType: "application/json; charset=utf-8"
        }).fail(function() {
            alerts.error();
        }).done(function(data) {
            if (!data.Success) {
                alerts.error();
                return;
            }
            that.offerModel.UpdateData(that.articleReference(),
                that.amount(),
                that.selectedOrderOptions(),
                that.selectedAdditionalWorkIds(),
                that.selectedDeliveryCountryId(),
                data.OfferGrossPrice);
            that.offerModel.OfferId = data.OfferId;
            that.offerModel.UserHasMailHead(data.UserHasMailHead);
            that.offerModel.AddOffer(parseInt(that.amount()), data.OfferGrossPrice);
            $("#OfferIdHidden").attr('value', data.OfferId);
            that.offerModel.Working(false);
        });
    };

    that.SetBeginnerMode = function() {
        var summary = $("#productConfigurationSummaryV2");
        summary.addClass("amountPricesBeginner");
    };

    that.RemoveBeginnerMode = function() {
        var summary = $("#productConfigurationSummaryV2");
        summary.removeClass("amountPricesBeginner");
    };

    that.AdjustProductConfigMode = function() {
        if (pageModelHndl.pProductContentModeModel.SelectedModeId() === "MODE_0") {
            that.SetBeginnerMode();
        } else {
            that.RemoveBeginnerMode();
        }
    };
};
